import { faCommentNodes } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { useOptionalAiAssistant } from "src/components/views/ai/assistant/AiAssistantContext.tsx";
import type { SxProps, Theme } from "@mui/material/styles";
import { KeyboardShortcutTooltipLabel } from "src/components/common/keyboard/KeyboardShortcutTooltipLabel.tsx";
import { AI_ASSISTANT_TOGGLE_SHORTCUT } from "src/components/views/ai/assistant/aiAssistantKeyboardShortcuts.ts";

export interface AiAssistantOpenButtonProps {
	sx?: SxProps<Theme>;
}

export const AiAssistantOpenButton = ({ sx }: AiAssistantOpenButtonProps) => {
	const aiAssistant = useOptionalAiAssistant();

	if (aiAssistant == null || !aiAssistant.isEnabled || aiAssistant.isOpen) return null;

	return (
		<AsyncButton
			icon={faCommentNodes}
			variant={"text"}
			aria-label={i18n.t("ai_assistant")}
			tooltip={
				<KeyboardShortcutTooltipLabel
					label={i18n.t("ai_assistant")}
					shortcut={AI_ASSISTANT_TOGGLE_SHORTCUT}
				/>
			}
			onClick={() => aiAssistant.openAiAssistant()}
			sx={sx}
		/>
	);
};
